import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IUserFile } from '@leedpulse-monorepo/interfaces';

async function downloadUserFile(
  userUid: string,
  file: IUserFile,
  auth: Authentication | null
): Promise<{ url: string; filename: string }> {
  try {
    if (!auth) throw new DownloadUserFileFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const blob = await HttpClient.getBlob(
      `/backoffice/users/${userUid}/files/${file.id}/download`,
      auth.token
    );

    return { url: URL.createObjectURL(blob), filename: file.name };
  } catch (e) {
    if (e instanceof DownloadUserFileFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new DownloadUserFileFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class DownloadUserFileFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default downloadUserFile;
